<template>
  <v-container fluid>
    <v-layout justify-center row wrap mt-3>
      <v-flex xs12 sm8 lg6 body-1 text-xs-justify>
        <p class="caption text-xs-right">Last update on June 9, 2022</p>
        <p>Hello reader,</p>
        <p>I am a software developer with 12 years of experience as a freelancer. I started off by making websites with
          PHP and JQuery. Pretty soon I've built my own custom CMS tailored to the needs of my clients. Since 2014 I've
          been working on web applications for a range of small to medium Croatian businesses. At the moment, my main
          web development focus are single page web applications built with Vue.js and Lumen.</p>
        <p>I've worked on a couple of startups as a mobile developer. Mainly for iOS in Objective C, but I also
          have some experience with React Native and Java/Kotlin for Android.</p>
        <p>Since August 2021 I am working as a game developer in Unreal Engine and C++.</p>
        <p>In May 2022 I started building my own light PHP framework for simple APIs. You can check it out <a target="_blank" href="https://github.com/srnikolic86/nevsphp-example">on GitHub</a>.</p>
        <p>In 2019 I have designed, developed and launched my personal product <a target="_blank" href="https://pausalko.com">Paušalko</a>, an invoicing app used by more than 100 Croatian businesses.</p>
        <p>When not programming, I am a father, a gamer and an avid traveler with 53 countries under my belt.</p>
      </v-flex>
    </v-layout>
    <v-layout justify-center row wrap mt-3>
      <v-flex xs12 sm8 lg6>
        <v-tabs v-model="activeTab" dark slider-color="green lighten-2">
          <v-tab :key="1" ripple>Projects</v-tab>
          <v-tab :key="2" ripple>Education timeline</v-tab>
          <v-tab-item :key="1">
            <v-layout justify-center row wrap>
              <v-flex v-for="(projectType, key) in projects" :key="key" xs12 pa-3>
                <v-card>
                  <v-toolbar color="green lighten-2" dark>
                    <v-toolbar-title>{{ projectType.name }}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon>
                      <v-icon>{{ projectType.icon }}</v-icon>
                    </v-btn>
                  </v-toolbar>
                  <v-list three-line dense>
                    <div v-for="(project, key) in projectType.projects" :key="key">
                      <v-list-tile>
                        <v-list-tile-content>
                          <v-list-tile-title :title="project.name" v-html="project.name"></v-list-tile-title>
                          <v-list-tile-sub-title v-html="project.details"></v-list-tile-sub-title>
                        </v-list-tile-content>
                      </v-list-tile>
                      <v-divider v-show="key != projectType.projects.length - 1"></v-divider>
                    </div>
                  </v-list>
                </v-card>
              </v-flex>
            </v-layout>
          </v-tab-item>
          <v-tab-item :key="2" class="pl-3 pr-3">
            <v-timeline>
              <v-timeline-item v-for="(event, key) in timeline" :key="key" color="green lighten-2" large>
                <template v-slot:opposite>
                  <span>{{ event.year }}</span>
                </template>
                <v-card class="elevation-2">
                  <v-card-text>
                    <div class="subheading mb-1">{{ event.title }}</div>
                    <v-divider></v-divider>
                    <div class="caption mt-1">{{ event.details }}</div>
                  </v-card-text>
                </v-card>
              </v-timeline-item>
            </v-timeline>
          </v-tab-item>
        </v-tabs>
      </v-flex>
    </v-layout>
    <v-layout justify-center row wrap mt-3>
      <v-flex xs12 text-xs-center>
        Built with <a target="_blank" href="https://vuejs.org">Vue.js</a> and <a target="_blank"
                                                                                 href="https://vuetifyjs.com">Vuetify</a>.
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: "Resume",
  data() {
    return {
      activeTab: null,
      publicPath: process.env.BASE_URL,
      timeline: [
        {
          year: 1992,
          title: 'Started elementary school',
          details: 'OŠ Marina Getaldića, Dubrovnik'
        },
        {
          year: 2000,
          title: 'Started high school',
          details: 'Gimnazija Dubrovnik, Dubrovnik'
        },
        {
          year: 2004,
          title: 'Started studying mathematics',
          details: 'PMF-MO, Zagreb'
        },
        {
          year: 2008,
          title: "Switched my studies to business and IT",
          details: "Vern', Zagreb"
        },
        {
          year: 2012,
          title: "Got my bachelor's degree",
          details: "Vern', Zagreb"
        },
        {
          year: 2012,
          title: "Started studying IT Management",
          details: "Vern', Zagreb"
        }
      ],
      projects: [
        {
          name: 'Web',
          icon: 'web',
          projects: [
            {
              name: 'Traditional CMS',
              details: 'PHP/JQuery | personal project',
              icon: ''
            },
            {
              name: 'CRM/ERP solution for a IT support business',
              details: 'PHP/JQuery/Lumen/Vue.js | lead developer',
              icon: ''
            },
            {
              name: 'CRM/ERP solution for a private language school',
              details: 'PHP/JQuery | sole developer',
              icon: ''
            },
            {
              name: 'CRM/ERP solution for an employment company',
              details: 'PHP/JQuery | lead developer',
              icon: ''

            },
            {
              name: 'ERP solution for a yacht cleaning agency',
              details: 'PHP/JQuery | sole developer',
              icon: ''
            },
            {
              name: 'ERP solution for a radio station',
              details: 'PHP/JQuery | lead developer',
              icon: ''
            },
            {
              name: 'DMS solution for a public organization',
              details: 'PHP/Vue.js | lead developer',
              icon: ''
            },
            {
              name: 'CRM/ERP solution for a gym',
              details: 'PHP/Vue.js | lead developer',
              icon: ''
            },
            {
              name: 'ERP solution for a yacht repair service',
              details: 'PHP/Vue.js | sole developer',
              icon: ''
            },
            {
              name: 'Phonebook database and API',
              details: 'Lumen | consultant',
              icon: ''
            },
            {
              name: 'CRM/ERP solution for a hair salon chain',
              details: 'Lumen/Vue.js | lead developer',
              icon: ''
            },
            {
              name: 'Project management solution for an architectural studio',
              details: 'Lumen/Vue.js | lead developer, business process analyst',
              icon: ''
            },
            {
              name: 'Voting system with email and SMS authentication',
              details: 'Lumen/Vue.js | sole developer',
              icon: ''
            },
            {
              name: 'Headless CMS',
              details: 'Lumen/Vue.js | personal project',
              icon: ''
            },
            {
              name: 'Invoicing app for small Croatian businesses (<a target="_blank" href="https://pausalko.com">Paušalko</a>)',
              details: 'Lumen/Vue.js | personal project',
              icon: ''
            },
            {
              name: 'Fiscalization and invoicing API for Croatian developers',
              details: 'Lumen/Vue.js | personal project',
              icon: ''
            },
            {
              name: 'Fabric categorisation app for conservators and restores',
              details: 'Lumen/Vue.js | personal project',
              icon: ''
            },
            {
              name: 'DMS system',
              details: 'Lumen/Vue.js | lead developer',
              icon: ''
            },
            {
              name: 'Timesheet app for a metallurgy company',
              details: 'Lumen/Vue.js | lead developer',
              icon: ''
            },
            {
              name: 'Project management solution for a plumbing and trading company',
              details: 'Lumen/Vue.js | lead developer',
              icon: ''
            },
            {
              name: 'Certificate holders records app for a financial company',
              details: 'Lumen/Vue.js | lead developer',
              icon: ''
            },
            {
              name: 'Reporting app for a real estate management company',
              details: 'Lumen/Vue.js | sole developer',
              icon: ''
            }
          ]
        }
        ,
        {
          name: 'Mobile',
          icon:
              'smartphone',
          projects:
              [
                {
                  name: 'IOT smart teddy bear iOS app with bluetooth support',
                  details: 'Objective C | sole developer',
                  icon: ''
                },
                {
                  name: 'Dog food and recreation management iOS app',
                  details: 'Objective C | sole developer',
                  icon: ''
                },
                {
                  name: 'Photo framing iOS app with customizer, shop, cart, payment and delivery',
                  details: 'Objective C | sole developer',
                  icon: ''
                },
                {
                  name: 'Body measurement and health iOS app based on photo analysis',
                  details: 'Objective C | sole developer',
                  icon: ''
                },
                {
                  name: 'Tourist apartment cleaning service in-house Android app',
                  details: 'Kotlin | sole developer',
                  icon: ''
                },
                {
                  name: 'Tourist destination info app for Android',
                  details: 'React Native | developer',
                  icon: ''
                },
                {
                  name: 'DMS system - mobile photo app',
                  details: 'NativeScrip/Vue.js | lead developer',
                  icon: ''
                }
              ]
        }
      ]
    }
  }
}
</script>

<style scoped>
  a, a:visited {
    color: #81c784;
  }
</style>
